import { pushGTMEvent } from 'containers/Player/utils/analytics';
import { getContentListV1 } from 'utils/homologacion/homologacion';

export const pushEventFromSearchCard = (
  isPopularSearch,
  contentInfo,
  infoGeneral,
) => {
  const isLive = getContentListV1?.IsLive(contentInfo);
  const contentType = getContentType(isLive, contentInfo);
  const infoToSend = {
    content_section: 'buscador',
    content_list: isPopularSearch ? 'busquedas populares' : 'resultados',
    content_id: isLive ? infoGeneral?.event_alf_id : contentInfo?.id,
    content_name: isLive ? infoGeneral?.name : contentInfo?.title,
    content_type: contentType,
    content_category: '',
    content_availability: '',
  };
  pushGTMEvent(infoToSend);
};

export const pushEventFromSearchTalentCard = (
  talentName,
  contentInfo,
) => {
  const isLive = getContentListV1?.IsLive(contentInfo);
  const contentType = getContentType(isLive, contentInfo);

  const infoToSend = {
    content_section: 'subcategorias por talentos',
    content_list: talentName,
    content_id: contentInfo?.id,
    content_name: contentInfo?.title,
    content_type: contentType,
    content_category: '',
    content_availability: '',
  };
  pushGTMEvent(infoToSend);
};

export const pushEventFromInputSearch = keyword => {
  const infoToSend = {
    search_term: keyword,
  };
  pushGTMEvent(infoToSend);
};

export const getContentType = (isLive, contentInfo) => {
  if (isLive) return 'canal tv';
  if (contentInfo?.is_series) return 'serie';
  return 'pelicula';
};
